import { useEffect, useRef } from 'react';
import { Analytics } from '../../utils/analytics';

const AD_PC = 'DAN-YVXTPvNwqU3gBvIM';
const AD_MOBILE = 'DAN-WCc5jLv5eV5ByQJ6';

const KakaoAd = ({ unitId, width, height, placement }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const ins = document.createElement('ins');
    ins.className = 'kakao_ad_area';
    ins.style.display = 'none';
    ins.setAttribute('data-ad-unit', unitId);
    ins.setAttribute('data-ad-width', String(width));
    ins.setAttribute('data-ad-height', String(height));
    container.appendChild(ins);

    const script = document.createElement('script');
    script.src = '//t1.kakaocdn.net/kas/static/ba.min.js';
    script.async = true;
    container.appendChild(script);

    // PC/모바일 KakaoAd가 모두 마운트되므로, 실제 뷰포트에서 보이는 쪽만 impression 집계.
    if (getComputedStyle(container).display !== 'none') {
      Analytics.adImpression(unitId, placement);
    }

    return () => {
      container.innerHTML = '';
    };
  }, [unitId, width, height, placement]);

  return <div ref={containerRef} />;
};

const AdBanner = () => {
  return (
    <div className="flex justify-center py-4">
      {/* PC: 728x90 */}
      <div className="hidden sm:block">
        <KakaoAd unitId={AD_PC} width={728} height={90} placement="pc" />
      </div>
      {/* 모바일: 320x100 */}
      <div className="sm:hidden">
        <KakaoAd unitId={AD_MOBILE} width={320} height={100} placement="mobile" />
      </div>
    </div>
  );
};

export default AdBanner;
